import { render, staticRenderFns } from "./WidgetRowsPerPage.vue?vue&type=template&id=2d9a5d68&lang=pug"
import script from "./WidgetRowsPerPage.vue?vue&type=script&lang=js"
export * from "./WidgetRowsPerPage.vue?vue&type=script&lang=js"
import style0 from "./WidgetRowsPerPage.vue?vue&type=style&index=0&id=2d9a5d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VSelect})
